import request from "_private/utils/request";

/**
 * 获取汇总列表数据
 * @param {*} data
 */
export function CollectFetchFindByPage(data) {
    return request({
        url: "/report/alarmSummary/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 获取企业报警汇总表头字段
 * @param 无参数
 */
export function FetchTableColumn() {
    return request({
        url: "/report/alarmSummary/getPageColumn",
        method: "post"
    });
}

// 导出汇总页面数据
export function exportListByCollect(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}

/**
 * 获取明细列表数据
 * @param {*} data
 */
export function DetailFetchFindByPage(data) {
    return request({
        url: "/report/storage/info/findByPage",
        headers: {type: "json"},
        method: "post",
        data
    });
}

// 导出明细页面数据
export function exportListByDetail(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}

// 获取报警类型下拉数据
export function getAlarmTypeData() {
    return request({
        url: "/report/alarm/alarmType",
        method: "post"
    });
}

// 门店明细列表数据
export function FetchStoreFindByPage(data) {
    return request({
        url: "/report/store/info/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

// 导出门店页面数据
export function exportListByStore(data) {
    return request({
        url: "/report/store/info/findByPage",
        method: "post",
        data
    });
}

// 冷藏车明细列表数据
export function FetchVehicleFindByPage(data) {
    return request({
        url: "/report/vehicle/info/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

// 导出冷藏车页面数据
export function exportListByVehicle(data) {
    return request({
        url: "/report/store/info/findByPage",
        method: "post",
        data
    });
}
